import Login from '../page/Login'
import Layout from '../page/Layout'
import Home from '../page/home/Home'
import EmployeeList from '../page/employee/EmployeeList'
import CompanyList from '../page/company/CompanyList'
import VillageList from '../page/village/VillageList'
import UserList from '../page/user/UserList'
import UserPayList from '../page/user/UserPayList'
import ChangePwd from '../page/home/ChangePwd'
import Income from '../page/income/Income'

const loginRoute = {
  path: '/login',
  name: 'login',
  meta: {
    title: '登录'
  },
  component: Login
}

const routes = [
  loginRoute,
  {
    path: '',
    name: '',
    component: Layout,
    children: [
      {
        path: '/',
        name: 'home',
        component: Home
      },
      {
        path: '/changepwd',
        name: 'changepwd',
        component: ChangePwd
      },
      {
        path: '/employee',
        name: 'employee',
        component: EmployeeList
      },
      {
        path: '/company',
        name: 'companyList',
        component: CompanyList
      },
      {
        path: '/village',
        name: 'villageList',
        component: VillageList
      },
      {
        path: '/user',
        name: 'userList',
        component: UserList
      },
      {
        path: '/income',
        name: 'income',
        component: Income
      },
      {
        path: '/paylist',
        name: 'userPayList',
        component: UserPayList
      }
    ]
  }
];

export default routes



// WEBPACK FOOTER //
// ./src/router/routes.js